<script>
  // Importa el componente SkeletonElement (asegúrate de tenerlo en tu proyecto)
  import SkeletonElement from './SkeletonElement.svelte'
</script>

<!-- Skeleton para la barra lateral -->
<div class="vertical-menu skeleton-sidebar">
  <div data-simplebar class="h-100">
    <!-- Simulación del menú lateral -->
    <div id="sidebar-menu">
      <ul class="metismenu list-unstyled" id="side-menu">
        <!-- Título del menú -->
        <li class="menu-title">
          <SkeletonElement width="80%" height="20px" />
        </li>
        <!-- Generamos 7 items de menú como ejemplo -->
        {#each Array(7) as _, index}
          <li class="mm-active">
            <!-- Cada item: un icono y un texto placeholder -->
            <a
              class="side-nav-link-ref"
              href="#"
              style="display: flex; align-items: center;"
            >
              <SkeletonElement
                width="20px"
                height="20px"
                styleCustom="margin-right: 10px;"
              />
              <SkeletonElement width="60%" height="15px" />
            </a>
          </li>
        {/each}
      </ul>
    </div>
  </div>
</div>

<style>
  .skeleton-sidebar {
    /* Puedes ajustar los estilos para que coincida con tu diseño */
    background-color: #f4f4f4;
    padding: 10px;
  }
</style>
